import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicLayout, { Eyebrow, H2 } from "@/components/public/PublicLayout";
import { ROUTES, C, SERIF } from "@/lib/publicLinks";

// Each choice routes to a deliberate monetization/triage path (existing routes reused).
const CHOICES = [
  { t: "My hair is shedding or thinning", to: ROUTES.hairScalp },
  { t: "I don't feel like myself", to: ROUTES.wellness },
  { t: "I'm concerned about weight or metabolism", to: `${ROUTES.wellnessAssessment}?context=weight_metabolic` },
  { t: "I'm experiencing women's wellness changes", to: `${ROUTES.wellnessAssessment}?context=womens_wellness` },
  { t: "I'm tired, stressed, or not sleeping well", to: `${ROUTES.wellnessAssessment}?context=stress_sleep` },
  { t: "My digestion has changed", to: `${ROUTES.wellnessAssessment}?context=digestion` },
  { t: "I want an in-person wellness service", to: ROUTES.services },
  { t: "I'm really not sure", to: ROUTES.navigator },
];

export default function StartHere() {
  return (
    <PublicLayout>
      <section style={{ background: C.lightBg }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <Eyebrow>Start Here</Eyebrow>
          <h1 className="text-4xl sm:text-5xl leading-[1.1] text-slate-900 max-w-3xl" style={SERIF} data-testid="starthere-h1">You Don't Have to Know Which Service You Need.</h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">Begin with the concern that sounds most like you. We'll point you toward the most appropriate next step — that's our job, not yours.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 gap-4">
          {CHOICES.map((c) => (
            <Link key={c.t} to={c.to} className="rounded-2xl p-5 bg-white flex items-center justify-between gap-3 hover:shadow-md transition group" style={{ border: `1px solid ${C.line}` }} data-testid={`starthere-choice-${c.t.toLowerCase().replace(/[^a-z]+/g, '-').slice(0, 24)}`}>
              <span className="text-slate-800 font-medium">{c.t}</span>
              <ArrowRight className="h-5 w-5 flex-shrink-0 group-hover:translate-x-0.5 transition" style={{ color: C.accent }} />
            </Link>
          ))}
        </div>
        <div className="mt-10 rounded-2xl p-6 text-center" style={{ background: C.lightBg }}>
          <p className="text-slate-800" style={SERIF}>You don't need to figure this out alone.</p>
          <p className="mt-2 text-sm text-slate-600">Every path begins with understanding your patterns — virtually, from wherever you are.</p>
        </div>
      </section>
    </PublicLayout>
  );
}
